export const isValidTab = (tab: string): tab is DashboardTab => {
  return /^inbox|drafts|search$/.test(tab)
}
export const paginationOptions = [
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: 100, title: '100' },
]
export const hidePaginationControls = (length: number) => {
  return length < paginationOptions[0].value ? true : false
}
export const hideRowsPerPage = (length: number) => {
  return length < paginationOptions[paginationOptions.length - 1].value ? true : false
}
